module.exports = __webpack_public_path__ + "media/images/avatar/development/parents/11-9bd831f8637abde1c9d6c40086960571.jpg";